$(document).ready(function () {
  $(document).on('click', '.area-zone-delete', function () {
    let area_id = $(this).data('area-id');
    let area_zone_id = $(this).data('area-zone-id');
    let confirm_message = $(this).data('confirm-message');

    if (!confirm(confirm_message)) {
      return false;
    }

    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_area_zone/delete',
      data: {
        area_id: area_id,
        area_zone_id: area_zone_id,
      },
    })
      .done(function (data) {
        if (data === true) {
          popupAlert();
          setTimeout(function () {
            document.location.href = '/organizer/area/' + area_id + '/zone';
          }, 1500);
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });

    return false;
  });
});
